/**
 * There are 25 levels here, but we don't have to use them all.
 * Shoutout to @copilot for creating these shadows :)
 */ const shadows = [
    "none",
    "0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 20px 6px rgba(208, 215, 230, 0.15), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 32px 3px rgba(208, 215, 230, 0.25), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 8px 24px rgba(0, 0, 0, 0.08), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)",
    "0px 0px 60px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.15)"
];
export default shadows;

//# sourceMappingURL=index.js.map